import { ThemeSchemaResponse } from '@api/api/theme-overview';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { fetchTheme } from '@terminal/services/overview-widget/overview-widget-service';
import { WretchError } from 'wretch/types';

export const QUERY_KEY_THEME_DETAILS_V2 = 'QUERY_KEY_THEME_DETAILS_V2';

export const useThemeDetails = ({
  themeId,
  enabled = true,
}: {
  themeId: string;
  enabled?: boolean;
}) => {
  const trimmedId = themeId.trim();
  const shouldRun = enabled && trimmedId.length > 0;
  return useQuery<ThemeSchemaResponse, WretchError>({
    queryKey: [QUERY_KEY_THEME_DETAILS_V2, trimmedId],
    queryFn: ({ signal }) => fetchTheme({ themeId: trimmedId, signal }),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: shouldRun,
  });
};
